import React from "react";

import { DateDifference } from "../utilities/DateUtils";
import { useProductStore } from "../stores/ProductStore";

import "../assets/scss/components/_order-in.scss";

export const OrderIn = ({ cutoff, product_id, first_available_delivery }) => {
	const [difference, setDifference] = React.useState({ hours: 0, minutes: 0, seconds: 0 });
	const [firstLoad, setFirstLoad] = React.useState(false);
	const { GetInfo } = useProductStore((state) => state);

	const RefreshInfo = () => {
		GetInfo(product_id, true);
	};

	React.useEffect(() => {
		const cutoffDate = new Date(first_available_delivery);
		cutoffDate.setHours(cutoff);
		cutoffDate.setMinutes(0);
		cutoffDate.setSeconds(0);

		const intervalId = setInterval(() => {
			setDifference(DateDifference(cutoffDate));
			if (!firstLoad) {
				setFirstLoad(true);
			}

			if (cutoffDate.getTime() <= new Date().getTime() || cutoffDate.getTime() === new Date().getTime()) {
				// clearInterval(intervalId);
				RefreshInfo();
			}
		}, 1000);

		return () => clearInterval(intervalId);
	}, [cutoff]);

	return (
		<div className={`order-in ${firstLoad ? "loaded" : ""} ${difference.hours === 0 ? "ending-soon" : ""}`}>
			If you order in the next
			{difference.hours > 0 ? <span className="hours-count">{String(difference.hours).padStart(2, "0")} hours and </span> : ""}
			{difference.minutes > 0 ? <span className="minutes-count">{String(difference.minutes).padStart(2, "0")} minutes</span> : ""}
			{difference.hours == 0 ? (
				<span className="seconds-count">
					{difference.minutes > 0 ? "and" : ""} {String(difference.seconds).padStart(2, "0")} seconds
				</span>
			) : (
				""
			)}
		</div>
	);
};
